import * as api from '../configs/config.json'
import * as packages from '../../package.json'
import CryptoJS from "crypto-js"
export default {
    // Version
    AppVersion () {
        const appversion = packages.version
        return appversion
    },
    AppTitle () {
        const apptitle = api.app_title
        return apptitle
    },
    AppDoc () {
        const appdoc = api.api_doc
        return appdoc
    },
    //UsersID get local storage users id
    UsersID () {
        let usersid = localStorage.getItem('local_tim_users')
        // localStorage.getItem('local_tim_users')
        return usersid
    },
    UsersType () {
        let usersdetail = JSON.parse(localStorage.getItem('local_tim_usersdetail'))
        let userstype   = usersdetail[0].users_type
        return userstype
    },
    UsersName () {
        let usersdetail = JSON.parse(localStorage.getItem('local_tim_usersdetail'))
        let usersname   = usersdetail[0].users_name
        return usersname
    },
    UsersCompany () {
        let usersdetail = JSON.parse(localStorage.getItem('local_tim_usersdetail'))
        let userstype   = usersdetail[0].users_company
        return userstype
    },
    UsersAvatar () {
        let usersdetail = JSON.parse(localStorage.getItem('local_tim_usersdetail'))
        let userstype   = usersdetail[0].users_avatar_url
        return userstype
    },
    TrueOrFalse (flag) {
        let returns = false
        if (flag === 'Y') {
            returns = true
        } else if (flag === 'F'){
            returns = true
        }
        return returns
    },
    Access (flag) {
        let returns = false
        if (flag === 1) {
            returns = true
        } else if (flag == true){
            returns = true
        }
        return returns
    },
    Method (flag) {
        let returns = false
        if (flag === 'POST') {
            returns = true
        }
        return returns
    },
    Gender(S) {
        let returns = true
        if (S === 'F') {
            returns = false
        }
        return returns
    },
     //FormatDateTime format date MM/DD/YYYY H:i:s
     FormatDateTimeSession (dates) {
        let today = new Date(dates)
        let dd = today.getDate()
        let mm = today.getMonth() + 1
        let yyyy = today.getFullYear()
        let hh = today.getHours()
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        if (hh < 10) {
            hh = '0' + hh
        }
        today = dd + '-' + mm + '-' + yyyy
        return today
    },
    //Format New Date
    FormatNewDate (dates) {
        let today = new Date(dates)
        let dd = today.getDate()
        let mm = today.getMonth() + 1
        let yyyy = today.getFullYear()
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    },
    Level(L) {
        let returns = 'High'
        if (L === 'L') {
            returns === 'Low'
        }
        return returns
    },
    UrlWS (url) {
        const hosts  = api.api_ws
        let newurl   = `${hosts}/${url}`
        return newurl
    },
    UrlPOST (url) {
        const hosts  = api.api_connection
        let newurl   = `${hosts}/${url}`
        return newurl
    },
    // Function untuk generate body POST dengan signature
    ParamPOST(param) {
        const key        = api.api_key;
        const secret     = api.api_secret;
        const login_user = this.UsersID();

        const now = new Date();

        const year   = now.getFullYear();
        const month  = String(now.getMonth() + 1).padStart(2,'0');
        const day    = String(now.getDate()).padStart(2,'0');
        const hour   = String(now.getHours()).padStart(2,'0');
        const minute = String(now.getMinutes()).padStart(2,'0');

        const time = `${year}${month}${day}${hour}${minute}`;

        // nonce random
        const nonce = Math.random().toString(36).substring(2,12);

        // build body awal tanpa secret
        const bodyObj = {
            key: key,
            secret: "",       // kosongkan dulu, server akan replace
            time: time,
            nonce: nonce,
            login_user: login_user,
            data: param
        };

        // stringifikasi body persis sebelum hash
        const bodyString = JSON.stringify(bodyObj);

        // hash body
        const bodyHash = CryptoJS.SHA256(bodyString).toString();

        // signature
        const signString = key + time + nonce + bodyHash;
        const hash = CryptoJS.HmacSHA256(signString, secret).toString();
        const signature = "core" + hash;

        // body final dikirim ke server
        bodyObj.secret = signature;

        return JSON.stringify(bodyObj);
    },
    // UploadPOST untuk curl/json API
    UploadPOST(url, param = "") {
        const hosts     = api.api_connection;
        const key       = api.api_key;
        const secret    = api.api_secret;
        const loginuser = this.UsersID();

        // waktu sekarang
        const now = new Date();
        const year   = now.getFullYear();
        const month  = String(now.getMonth()+1).padStart(2,'0');
        const day    = String(now.getDate()).padStart(2,'0');
        const hour   = String(now.getHours()).padStart(2,'0');
        const minute = String(now.getMinutes()).padStart(2,'0');
        const time = `${year}${month}${day}${hour}${minute}`;

        // nonce random
        const nonce = Math.random().toString(36).substring(2,12);

        // body untuk hash
        const bodyObj = {
            key: key,
            secret: "",
            time: time,
            nonce: nonce,
            login_user: loginuser,
            data: param || {}
        };

        const bodyString = JSON.stringify(bodyObj);
        const bodyHash = CryptoJS.SHA256(bodyString).toString();
        const signString = key + time + nonce + bodyHash;
        const hash = CryptoJS.HmacSHA256(signString, secret).toString();
        const signature = "core" + hash;

        // buat URL query params
        let fullUrl = `${hosts}/${url}?key=${key}&secret=${signature}&time=${time}&nonce=${nonce}&login_user=${loginuser}`;

        if (param && typeof param === "string" && param.length > 0) {
            fullUrl += "&" + param; // append param tambahan kalau ada
        }

        return fullUrl;
    },
    //FormatDateFull format date MM/DD/YYYY H:i:s
    FormatDateFull (date) {
        if (!date) return null
        const  dates             = date.split('T')
        const [year, month, day] = dates[0].split('-')
        const newmonth           = this.ShortMonthNameEng(month) 
        return `${newmonth} ${day} ${year}`
    },
    //ShortMonthNameEng MonthNameEnglish
    ShortMonthNameEng (months) {
        let monthsindo = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let getmonth = monthsindo[parseInt(months) - 1]
        return getmonth
    },
    //ShortMonthNameEng MonthNameEnglish
    ShortMonthNameIndo (months) {
        let monthsindo = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des']
        let getmonth = monthsindo[parseInt(months) - 1]
        return getmonth
    },
    //FullMonthNameIndo MonthNameEnglish
    FullMonthNameIndo (months) {
        let monthsindo = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
        let getmonth = monthsindo[parseInt(months) - 1]
        return getmonth
    },
    //Today get the day now
    Today () {
        let today = new Date()
        let dd = today.getDate()
        let mm = today.getMonth() + 1
        let yyyy = today.getFullYear()
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    },
    DayNameIndo (date) {
        var days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
        var d = new Date(date)
        var dayname = days[d.getDay()]
        return dayname
    },
    //FormatDateFull format date MM/DD/YYYY
    FormatDateIndoWithDayName (date) {
        if (!date) return null
        else if (date === '1900-01-01') {
            return  null
        } else {
            const dates              = date
            const [year, month, day] = dates.split('-')
            const newmonth           = this.ShortMonthNameIndo(month)
            var dayname              = this.DayNameIndo(date)
            return `${dayname}, ${newmonth} ${day} ${year}`
        }
    },
    DateNull (date) {
        let returns = date
        if (date === '1900-01-01') {
            returns = ''
        }
        return returns
    },
    MinuteDiff(time1, time2) {
        let diff     = new Date("01/01/2007 " + time2) - new Date("01/01/2007 " + time1)
        let diffHrs  = Math.floor((diff % 86400000) / 3600000); // hours
        let diffMins = Math.round(((diff % 86400000) % 3600000) / 60000); // minutes
        let returns  = diffHrs + ' Jam'
        if (diffMins > 0) {
            returns  += ' ' + diffMins + ' Menit'
        }
        return returns;
    },
    //FormatDateTime format date MM/DD/YYYY H:i:s
    FormatDateTime (date) {
        if (date === '1900-01-01T00:00:00Z') {
            return  null
        } else {
        if (!date) return null
        const [dates, times]     = date.split('T')
        const [year, month, day] = dates.split('-')
        const newtime            = times.split('.')
        const splittime          = newtime[0].split(':')
        const newmonth           = this.ShortMonthNameEng(month) 
            return `${newmonth} ${day} ${year} ${splittime[0]}:${splittime[1]}`
        }
    },
    TodayYYYYMMDD () {
        let today = new Date()
        let dd = today.getDate()
        let mm = today.getMonth() + 1
        let yyyy = today.getFullYear()
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    },
    EncodeUrl(value) {
        let returns = value
        if (value === undefined) {
          returns = ''
        }
        let today       = this.TodayYYYYMMDD()
        let login_user  = this.UsersID()
        let encode      = btoa(login_user+today+'&'+returns)
        return encode
      },
    DecodeUrl(value) {
        let returns = value
        if (value === undefined) {
            returns = ''
        }
        let decode  = atob(returns)
        let split   = decode.split('&')
        let id      = split[1]
        return id
    },
    DecodeIndexUrl(value,index) {
        let returns = value
        if (value === undefined) {
            returns = ''
        }
        let decode  = atob(returns)
        let split   = decode.split('&')
        let id      = split[index]
        return id
    },
    Split (data, delimiter) {
        let split = data.split(delimiter)
        return split
    },
    FormatTimeToWords(timeString) {
        // Memisahkan jam dan menit dari input
        const [hours, minutes] = timeString.split(':');
        
        // Menghapus angka nol di depan jam jika ada, lalu tambahkan kata-kata
        let formattedHours = parseInt(hours, 10) + ' Jam';
        let formattedMinutes = parseInt(minutes, 10) + ' Menit';
        if (parseInt(hours, 10) === 0) {
            formattedHours = ""
        }
        return `${formattedHours} ${formattedMinutes}`;
    },
    PastDate(daysAgo) {
        const today = new Date(); // Tanggal hari ini
        const pastDate = new Date(); // Salinan objek tanggal
        pastDate.setDate(today.getDate() - daysAgo); // Kurangi hari sesuai input
        return pastDate.toISOString().split('T')[0]; // Format ke "YYYY-MM-DD"
    },
    DateDiff(a, b) {
        // Discard the time and time-zone information
        if (a !== undefined && b !== undefined) {
            if (a !== '1900-01-01' && b !== '1900-01-01') {
                const _MS_PER_DAY = 1000 * 60 * 60 * 24
                let date1  = new Date(a)
                let date2  = new Date(b)
                const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
                const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate())
                console.log(a,b)
                return Math.floor((utc2 - utc1) / _MS_PER_DAY)
            }
        } else {
            return 0
        }
    },
    //FormatDateFull format date MM/DD/YYYY H:i:s
    FormatDateIndo (date) {
        if (!date) return null
        const  dates             = date.split('T')
        const [year, month, day] = dates[0].split('-')
        const newmonth           = this.ShortMonthNameEng(month) 
        return `${day} ${newmonth} ${year}`
    },
    ErrorCode () {
        return 'Tidak ada Data'
    },
    NewFormatNumber (value, fixed) {
        let val = (value / 1).toFixed(fixed).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    Ages(birthdate) {
        const today = new Date();
        const birthdateobj = new Date(birthdate);
    
        let ages = today.getFullYear() - birthdateobj.getFullYear();
        const months = today.getMonth() - birthdateobj.getMonth();
        const days = today.getDate() - birthdateobj.getDate();
    
        // Periksa apakah ulang tahun tahun ini belum lewat
        if (months < 0 || (months === 0 && days < 0)) {
            ages--;
        }
    
        return ages;
    },
    GetMonth (date) {
        const formatdate = new Date(date)
        const months = formatdate.getMonth()
        return months
    },
    CheckImage(filename) {
        // Daftar ekstensi gambar yang valid
        const validExtensions = ['jpg', 'jpeg', 'png'];
      
        // Ambil ekstensi file
        const extension = filename.split('.').pop().toLowerCase();
      
        // Periksa apakah ekstensi termasuk dalam daftar valid
        return validExtensions.includes(extension);
    },
    OpenUrl(url) {
        if (url === '') {
            alert('URL Not Found')
        } else {
            window.open(url)
        }
    },
    ConvNom(amount) {
        let convert = String(amount)
        if (convert === '') {
            convert = '0'
        }
        return convert
    },
    GetFilenameFromUrl(url) {
        return url.substring(url.lastIndexOf('/') + 1);
    },
    ConvertToLinks(text) {
        // Regex untuk mendeteksi URL (http, https)
        const urlRegex = /(https?:\/\/[^\s]+)/g;
    
        // Gantilah URL yang cocok dengan elemen <a>
        let data = this
        return text.replace(urlRegex, function(url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${data.GetFilenameFromUrl(url)}</a>`;
        });
    },
    Year () {
        let today = new Date()
        let yyyy = today.getFullYear()
        return yyyy
    },
    BalanceModul (type) {
        let feedback = ''
        if (type === 'leave') {
            feedback = 'Cuti Tahunan'
        } else if (type === 'medical') {
            feedback = 'Kesehatan'
        } else if (type === 'entertainment') {
            feedback = 'Bina Relasi'
        } else if (type === 'transportation') {
            feedback = 'BBM, Parkir dan Tol'
        }
        return feedback
    },
    StatusStandard(status) {
        let feedback = ''
        if (status === 'R') {
            feedback = 'Request'
        } else if (status === 'A') {
            feedback = 'Disetujui'
        } else if (status === 'J') {
            feedback = 'Ditolak'
        }
        return feedback
    },
    MonthYearName() {
        const date = new Date();
        const namaBulan = this.FullMonthNameIndo(date.getMonth() + 1);
        const tahun = date.getFullYear();
      
        return `${namaBulan} ${tahun}`;
    },
    ProductName(data) {
        const value = data.replace('Penjaminan', '')
        return value
    },
    HeaderStyle(i) {
      const colors = [
        "linear-gradient(90deg,#114E87,#DF171D)",
        "linear-gradient(90deg,#7c3aed,#22c55e)",
        "linear-gradient(90deg,#2563eb,#f59e0b)",
        "linear-gradient(90deg,#db2777,#06b6d4)",
      ];
      return { background: colors[i % colors.length] };
    },
    RateUnitDesc(data) {
        let returns = ''
        if (data === 'C') {
            returns = '%'
        } else if (data === 'M') {
            returns = '%o'
        } else if (data === 'F') {
            returns = ''
        }
        return returns
    },
    AttachmentIcon (icon) {
        let returns = ''
        if (icon === 'pdf') {
            returns = 'mdi-file-pdf-box'
        } else if (icon === 'png') {
            returns = 'mdi-file-png-box'
        } else if (icon === 'jpg' || icon === 'jpeg') {
            returns = 'mdi-file-jpg-box'
        } else if (icon === 'xls' || icon === 'xlsx') {
            returns = 'mdi-file-excel-box'
        } else if (icon === 'doc' || icon === 'docs') {
            returns = 'mdi-file-word-box'
        } 
        return returns
    },
    Variable (flag, position) {
        let data = []
        if (flag === 'confirm') {
                data = [390,'success','error','primary white--text','white']
        }
        return data[position]
    },
    NoPriviledge (modul) {
        let returns = "You Dont have access modul `"+ modul + "`" 
        return returns
    },
    TimeHour (time) {
        const [hours] = time.split(':')
        return `${hours}`
    },
    YearMonthDiff (date) {
        let tanggal1 = new Date()
        let tanggal2 = new Date(date)

        // Hitung selisih antara kedua tanggal
        let selisihTanggal = new Date(tanggal1 - tanggal2)

        // Ekstrak tahun dan bulan dari selisih tanggal
        let tahun = selisihTanggal.getUTCFullYear() - 1970 // 1970 adalah tahun referensi
        let bulan = selisihTanggal.getUTCMonth()

        // Konversi selisih ke format "tahun bulan"
        let selisihTahunBulan = tahun + "-Tahun " + bulan + " Bulan"
        if (tahun === 0) {
            selisihTahunBulan = bulan + " Bulan"
        }
        return selisihTahunBulan
    },
    ActivedFlag (flag) {
        let returns = 'N'
        if (flag === true) {
            returns = 'Y'
        }
        return returns
    },
    YesOrNo (flag) {
        let returns = 'Tidak'
        if (flag === 'Y') {
            returns = 'Ya'
        }
        return returns
    },
}